import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  OrderFactsService,
} from './order.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [
    OrderFactsService
  ]
})
export class OrderFactsModule {}
